"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouter = void 0;
var router_1 = require("next/router");
var useRouter = function () {
    var router = (0, router_1.useRouter)();
    return router;
};
exports.useRouter = useRouter;
